require('./translation');
I18n.defaultLocale = 'ja';
I18n.locale = 'ja';



// WEBPACK FOOTER //
// ./app/javascript/config/i18n_translation.js